import { OrganizationAction } from "@common/userOrganizationRoles";
import { useCanPerformOrganizationAction } from "./useCanPerformOrganizationAction";

/**
 * Returns whether the current user can view the organization's member access
 * log (audit trail of which member accessed which client, and when).
 * Requires the VIEW_ORGANIZATION_MEMBER_ACCESS_LOG org-role action
 * (admins/owners only) — the underlying read API is also `@AdminAccess()`
 * gated server-side, so this hook only controls UI visibility.
 */
export function useCanViewOrganizationMemberAccessLog(): boolean {
    return useCanPerformOrganizationAction(
        OrganizationAction.VIEW_ORGANIZATION_MEMBER_ACCESS_LOG,
    );
}
